import { request } from "@/utils/remoteRequest";

export function getList(data) {
  return request({
    url: "/users/list",
    method: "post",
    data,
  });
}

export function findUsersByDeptCode(data) {
  return request({
    url: "/users/findUsersByDeptCode",
    method: "post",
    data,
  });
}

export function findUsersByPropertyTypeId(data) {
  return request({
    url: "/users/findUsersByPropertyTypeId",
    method: "post",
    data,
  });
}

export function getPage(data) {
  return request({
    url: "/users/page",
    method: "post",
    data,
  });
}

export function deleteUser(data) {
  return request({
    url: "/users/delete",
    method: "post",
    data,
  });
}

export function validatePassword(data) {
  return request({
    url: "/users/validatePassword",
    method: "post",
    data,
  });
}

export function saveUser(data) {
  return request({
    url: "/users/saveUser",
    method: "post",
    data,
  });
}

export function getUserInfo(data) {
  return request({
    url: "/main/searchCurUserInfo",
    method: "post",
    data,
  });
}

export function saveUserInfo(data) {
  return request({
    url: "/users/saveUserInfo",
    method: "post",
    data,
  });
}

export function resetUserPwd(data) {
  return request({
    url: "/users/resetPassword",
    method: "post",
    data,
  });
}
